import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import MainButtons from './toolbar/MainButtons';
import BackButton from '../BackButton/BackButton';
import { APP_HEADER_HEIGHT } from './appHeaderHeight';

interface AppHeaderProps {
  mobile: boolean;
  /** The current page's route title; empty on routes with none. */
  title: string;
  initials: string;
  onOpenMenu: () => void;
  onOpenAccountMenu: (anchor: HTMLElement) => void;
}

export { APP_HEADER_HEIGHT };

/**
 * The white page header that replaced the blue toolbar once the brand moved
 * into the rail: the page title on the left, notifications and the account
 * avatar on the right. On a phone it also carries the menu button and the
 * Ask Reva chip, since the rail is hidden in a sheet.
 */
const AppHeader: React.FC<AppHeaderProps> = ({
  mobile,
  title,
  initials,
  onOpenMenu,
  onOpenAccountMenu,
}) => (
  <AppBar
    position="sticky"
    elevation={0}
    color="inherit"
    sx={{
      backgroundColor: '#fff',
      borderBottom: '1px solid #e6ebf0',
      color: 'text.primary',
    }}
  >
    <Toolbar sx={{ minHeight: `${APP_HEADER_HEIGHT}px !important`, gap: 1 }}>
      {mobile && (
        <IconButton
          edge="start"
          aria-label="Open menu"
          onClick={onOpenMenu}
          sx={{ color: 'text.secondary' }}
        >
          <MenuIcon />
        </IconButton>
      )}
      <BackButton />
      <Typography
        component="h1"
        data-testid="app-header-title"
        noWrap
        sx={{ fontSize: '1.05rem', fontWeight: 800, letterSpacing: '-0.01em' }}
      >
        {title}
      </Typography>
      <Box sx={{ flex: 1 }} />
      <MainButtons showReva={mobile} />
      {!mobile && (
        <IconButton
          aria-label="Account menu"
          aria-haspopup="menu"
          data-testid="header-account"
          onClick={(event) => onOpenAccountMenu(event.currentTarget)}
          sx={{ p: 0.5 }}
        >
          <Avatar
            sx={{
              width: 34,
              height: 34,
              bgcolor: 'secondary.main',
              fontSize: '0.8rem',
              fontWeight: 700,
            }}
          >
            {initials}
          </Avatar>
        </IconButton>
      )}
    </Toolbar>
  </AppBar>
);

export default AppHeader;
